/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function DeleteIcon({ size = 'xsmall', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      width={sizes[size]}
      height={sizes[size]}
      viewBox="0 0 20 20"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M12 0c.552 0 1 .449 1 1v1h5.487a.5.5 0 0 1 .513.486v.028a.5.5 0 0 1-.513.486L17 2.999v15.004a2 2 0 0 1-1.85 1.992L15 20H3.993A1.993 1.993 0 0 1 2 18.003V2.999L.514 3A.5.5 0 0 1 0 2.514v-.028A.5.5 0 0 1 .514 2H6V1c0-.551.448-1 1-1h5zm4 3H3v15.003c0 .55.445.997.993.997H15a1 1 0 0 0 1-.997V3zM7.5 7c.276 0 .5.18.5.4v7.2c0 .196-.177.36-.41.394L7.5 15c-.276 0-.5-.18-.5-.4V7.4c0-.196.177-.36.41-.394L7.5 7zm4 0c.276 0 .5.18.5.4v7.2c0 .196-.177.36-.41.394L11.5 15c-.276 0-.5-.18-.5-.4V7.4c0-.196.177-.36.41-.394L11.5 7zm.5-6H7v1h5V1z"
      />
    </svg>
  );
}
